import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidFogReading } from '../../../../mechanics/rid-fog-reading/rid-fog-reading';
import { injectQueryParams } from '../../../../utils/route.utils';

@Component({
  selector: 'app-fog-reading-page',
  imports: [RidFogReading],
  templateUrl: './fog-reading-page.html',
})
export class FogReadingPage {
  protected readonly $router = inject(Router);

  protected readonly queryParams = injectQueryParams();
  protected readonly pace = computed(() => parseInt(this.queryParams()['pace'] ?? '200'));
}
